import React from "react";
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@material-ui/core/Tooltip";

export default function TextActionButton({
    icon = null,
    title = "",
    children,
    onClick = () => {},
    color = "primary",
    ...otherProps
}) {
    const content = (
        <Button color={color} onClick={onClick} {...otherProps}>
            {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
            {children}
        </Button>
    );

    return title ? (
        <Tooltip title={title}>
            <span>{content}</span>
        </Tooltip>
    ) : (
        content
    );
}
